import { CheckCookieRoute } from 'api/checkCookie';
import ApiRoute from 'utils/apiRoute';

export const checkCookieRoute: CheckCookieRoute = new ApiRoute('/checkCookie', 'GET');
